export default {
    solicitacoes: [],
    solicitacao: {},
    produtosSolicitacao: [],
    carregandoProdutosCotacao: false,
    ultimaAtualizacaoListaSolicitacao: Date
}
